import { useEffect, useState } from 'react';

export const useAnimatedMounting = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleElementHide: (args?: any) => void,
  animationDuration: number,
) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAnimatedUnmount = (elementHideHandlerArgs?: any) => {
    setIsMounted(false);

    setTimeout(() => {
      handleElementHide(elementHideHandlerArgs);
    }, animationDuration);
  };

  return { isMounted, handleAnimatedUnmount };
};
